import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import moment from "moment";

import DeleteIcon from "@material-ui/icons/Delete";

import SyllabusIcon from "../../../../../Assets/Logo/SyllabusIcon.svg";
import { useStyles } from "../../UserAssignments.css";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import CustomDialogBox from "../../../../../Components/CustomDialogBox/CustomDialogBox";
import { getUserRefreshToken } from "../../../../../Redux/Actions/actions";

class MobileAssignmentBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editStatus: false,
      assignmentId: "",
      dialogOpen: false,
      notificationOpen: false,
    };
  }

  handleEdit = (assignmentId) => {
    this.setState({
      editStatus: true,
      assignmentId,
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleDialogOpen = (assignmentId) => {
    this.setState({
      dialogOpen: true,
      assignmentId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  handleDeleteAcademic = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/assignments/${this.state.assignmentId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.userToken}`,
          },
        }
      );
      if (response.data.message === "Assignment deleted successfully") {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getAssignments();
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.handleDeleteAcademic();
      }
    }
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  render() {
    const { classes, data } = this.props;
    return (
      <Paper className={classes.paper}>
        <ListItem>
          <b style={{ flexGrow: 1 }}>{data.subject}</b>
          <Tooltip arrow title="Delete" onClick={this.handleDialogOpen}>
            <DeleteIcon style={{ color: "red" }} />
          </Tooltip>
        </ListItem>
        <ListItem>
          <div>Deadline:- {moment(data.submissionDate).format("LL")}</div>
        </ListItem>
        {data.files.map((file, index) => (
          <Tooltip
            key={index}
            arrow
            title={`${data.title}`}
            className={classes.tooltip}
            onClick={() =>
              this.props.history.push(`/assignments/details/${data._id}`)
            }
          >
            <img
              src={SyllabusIcon}
              alt="Syllabus"
              style={{ width: 80, height: 80 }}
            />
          </Tooltip>
        ))}
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteAcademic}
        />
      </Paper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(MobileAssignmentBody)));
